import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin/warehouses/$warehouseId/")({
  beforeLoad: () => {
    throw redirect({ to: "info" })
  },
})
